import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import {
	AccountInfo,
	InteractionRequiredAuthError,
	InteractionStatus,
} from "@azure/msal-browser";
import { callMsGraph } from "../../../services/MSALGraph";
import { loginRequest } from "../../../services/authConfig";
import graybarLogo from "../../../graybarLogo.png";
import HomeIcon from "@mui/icons-material/Home";
import "./header.scss";
import { connect } from "react-redux";
export const TOKENDATA = "TOKENDATA";
import HomeLogo from "../../../assets/mainHome.svg";
import Menus from "./Menu";
import { Divider, Modal, Button } from "rsuite";
import { Settings } from "@mui/icons-material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FileDownloadIcon from "@rsuite/icons/FileDownload";

declare global {
  interface Window {
    OneTrust?: {
      ToggleInfoDisplay?: () => void;
      [key: string]: any;
    };
  }
}

const Header = (props: any) => {
	const { instance, inProgress } = useMsal();
	const [userData, setUserData] = useState<any>(null);
	const location = useLocation();
	const [selectedNav, setSelectedNav] = useState<string>("");
	const [pdfPopUp, setPdfPopUp] = useState(false);
	const navigate = useNavigate();
	const borderBottomRoutes = ["/nia-simulator"];
	useEffect(() => {
		if (!userData && inProgress === InteractionStatus.None) {
			callMsGraph()
				.then((response) => {
					props.onTokenChange(localStorage.getItem("accessToken"));
					setUserData(response);
					localStorage.setItem("user_email", response.mail);
					localStorage.setItem("user_name", response.displayName);
				})
				.catch((e) => {
					if (e instanceof InteractionRequiredAuthError) {
						instance.acquireTokenRedirect({
							...loginRequest,
							account: instance.getActiveAccount() as AccountInfo,
						});
					}
				});
		}
	}, [inProgress, userData, instance]);
	const navBarDropDowns: NavbarMenu[] = [
		{
			title: "Baseline and Performance",
			subMenus: [
				{
					name: "Category Alerts",
					route: "/alerts",
				},
				{
					name: "Category Performance",
					route: "/category-performance",
				},
				{
					name: "Category Baseline",
					route: "/baseline",
				},
				// {
				// 	name: "Industry Insights",
				// 	route: "/industry-insights",
				// },
			],
		},
		{
			title: "Category Strategy Recommendations",
			subMenus: [
				{
					name: "Category Profitability",
					route: "/profitability",
				},
			],
		},
		{
			title: "NIA",
			subMenus: [
				{
					name: "NIA Peer Benchmark",
					route: "/opportunities",
				},
				{
					name: "Forward Buy Recommendations",
					route: "/nia-simulator",
				},
			],
		},
		{
			title: "Sourcing & Strategic Supplier Negotiations",
			subMenus: [
				{
					name: "Cost Optimization",
					route: "/cost-optimization",
				},
				{
					name: "Supplier Consolidation",
					route: "/supplier-consolidation",
				},
			],
		},
		{
			title: "Assortment & Product",
			subMenus: [
				{
					name: "SKU Management",
					route: "/sku-management",
				},
				{
					name: "Portfolio Gap",
					route: "/portfolio",
				},
			],
		},
		{
			title: "Commercial & Pricing",
			subMenus: [
				{
					name: "Commercial Optimization",
					route: "/pricing",
				},
			],
		},
		{
			title: "Execution Tracking",
			subMenus: [
				{
					name: "Category Progress Tracker",
					route: "/progress-tracker-category",
				},
				{
					name: "Manager's Dashboard",
					route: "/category-progress-tracker?view=manager",
				},
				{
					name: "Category Status Inputs",
					route: "/category-progress-tracker?view=category",
				},
				// {
				// 	name: "Category Strategy Implementation",
				// 	route: "/value-capture",
				// },
				// {
				// 	name: "NIA Negotiations",
				// 	route: "/nia-negotiations",
				// },
				// {
				// 	name: "Preferred Supplier",
				// 	route: "/preferredSupplier",
				// },
				// {
				// 	name: "Margin Preservation Dashboard",
				// 	route: "/margin-preservation",
				// },
			],
		},
		{
			title: "Value Tracking",
			subMenus: [
				{
					name: "Category Strategy Implementation",
					route: "/value-capture",
				},
				{
					name: "NIA Negotiations",
					route: "/nia-negotiations",
				},
				{
					name: "Margin Preservation Dashboard",
					route: "/margin-preservation",
				},
				{
					name: "Preferred Supplier",
					route: "/preferredSupplier",
				},
			],
		},
	];
	const [selectedNavButton, setSelectedNavButton] =
		useState("SupplierDashboard");
	const HandleNavButtonClick = (event: any) => {
		// if(event.name !== "SKUSubstitution" && event.name !== "CrossSell"){
	};
	const [dataRange, setDataRange] = useState<any>(null);
	const [salesInfo, setSalesInfo] = useState<any>(null);
	const [openedMenu, setOpenedMenu] = useState("");
	const handleOpen = (openedTitle: string) => {
		if (openedTitle === openedMenu) setOpenedMenu("");
		else setOpenedMenu(openedTitle);
	};
	useEffect(() => {
		handleOpen("");
		let currentNavButton = "";
		let currentNavText = "";
		const currentFullPath = location.pathname + location.search;
		navBarDropDowns.forEach((n: NavbarMenu) => {
			if (currentFullPath == "/home") {
				currentNavButton = "Home";
				currentNavText = "Home";
			} else {
				const subMenu = n.subMenus.find(
					(s) => s.route === currentFullPath
				);
				if (subMenu) {
					currentNavButton = n.title;
					currentNavText = subMenu.name;
				}
			}
		});
		if (location.pathname == "/profitability") {
			setDataRange("Jan'23 - Dec'23 Sales Data");
			setSalesInfo(
				"Sales in Network (excluding NOFs, LOTs, Canada & Subs)"
			);
		} else if (location.pathname == "/performance") {
			setDataRange("Jan'23 - Jul'24 Sales Data");
			setSalesInfo(
				"Sales in Network (excluding NOFs, LOTs, Canada & Subs)"
			);
		} else if (
			["/nia-simulator", "/opportunities"].includes(location.pathname)
		) {
			setDataRange("Jan'23 - Jul'24 Sales Data");
			setSalesInfo("Sales in Network (excluding Canada & Subs)");
		} else {
			setDataRange("Jan'23 - Dec'23 Sales Data");
			setSalesInfo(
				"Sales in Network (excluding NOFs, LOTs, Canada & Subs)"
			);
		}
		setSelectedNavButton(currentNavButton);
		setSelectedNav(currentNavText);
	}, [location.pathname, location.search]);

	const handleAlertClose = () => setPdfPopUp(false);

	return (
		<>
			<Modal
				backdrop={true}
				role="alertdialog"
				open={pdfPopUp}
				onClose={handleAlertClose}
				size="lg"
				className="pdf-view-modal"
			>
				<Modal.Body style={{ padding: 0, height: "100%", maxHeight: '90vh' }}>
					<Modal.Header closeButton={false}>
						<div className="flex">
							<div className="w-full"></div>
							<div className="text-center text-[2.5vh] w-full mb-[3vh]">
								 User Manual
							</div>
							<div className="w-full flex justify-end">
								<Button
									onClick={() => {
										handleAlertClose()
									}}
									style={{ background: "#941c14" }}
									className="modal-close-btn  h-[4vh]"
								>
									Close
								</Button>
							</div>
						</div>
					</Modal.Header>
					
					<iframe src={"/CATMAN_Toolkit_User_Manual.pdf#navpanes=0&toolbar=1"} 
					style={{
						width: "100%",
						height: "90%",
						border: "none",
						display: "flex",
					}}
					allowFullScreen
					title="PDF Viewer"></iframe>

				</Modal.Body>
			</Modal>
			<div className="header-container flex flex-col justify-between w-full bg-white shadow-normal border-b border-[#d9d9d9]">
				<div className="flex w-full justify-between px-[2%] py-[0.4vw] pb-[0px]">
					<div className="logoContainer">
						<span className="font-[700] text-[#03234d]">
							CATMAN
							
						</span>
						<span className="marginBrain">
							<Divider className="line" vertical />
						</span>
						<div className="sublogoContainer">
							<div className="text-fs20 font-[800] leading-none">
								<span className="text-deloitteGreen">WD</span>
								<span className="text-black">
									Edge <sup>TM</sup>
								</span>
							</div>
							<div className="text-fs14 leading-none">
								<span className="leading-none">By</span>
								<span className="font-bold leading-none">
									Deloitte
								</span>
								<span
									style={{
										fontWeight: "bold",
										color: "#86BC25",
									}}
								>
									.
								</span>
							</div>
						</div>
					</div>
					<div className="flex gap-x-[1vh]">
						{
						selectedNavButton == "Home" &&
						<Button 
							appearance="ghost"
							color="green"
							size="xs"
							className="flex gap-x-[1vh]"
							onClick={()=>{
								setPdfPopUp(true);
							}}
						>
							<span>
								User Manual
							</span>
							<FileDownloadIcon
								color="green"
								className="text-fsre12 cursor-pointer"
							/>
						</Button>
						}
						<SettingsMenu/>
					</div>
				</div>
				<div className="flex w-full px-[0.8%] gap-0.2 mt-1 bg-white shadow-md border-t border-[#d9d9d9]">
					<Link
						to={"/home"}
						className={`hover:text-gray-800 text-black flex justify-start items-center cursor-pointer px-[1vh]  ${
							selectedNavButton == "Home"
								? "border-b-[3px] border-deloitteGreen font-semibold text-deloitteGreen"
								: ""
						}`}
					>
						<img className="w-[1vw]" src={HomeLogo} alt="Home" />
						<p
							className={`text-[1.8vh] font-semibold ${
								selectedNavButton == "Home"
									? "font-semibold text-deloitteGreen"
									: ""
							}`}
						></p>
					</Link>
					{navBarDropDowns.map((dropDownMenu) => (
						<div
							key={dropDownMenu.title}
							onClick={() => {
								handleOpen(dropDownMenu.title);
							}}
						>
							<Menus
								menu={dropDownMenu}
								isSelected={
									selectedNavButton === dropDownMenu.title
								}
								isOpen={openedMenu === dropDownMenu.title}
								handleOpen={handleOpen}
							/>
						</div>
					))}
				</div>
			</div>
		</>
	);
};

const SettingsMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | SVGSVGElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<SVGSVGElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickOnCookieSettings = () => {
    if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === "function") {
      window.OneTrust.ToggleInfoDisplay();
    } else {
      console.warn("OneTrust or ToggleInfoDisplay not available");
    }
    handleClose();
  };

  return (
    <div>
      <Settings className="settings-icon" onClick={(e) => handleClick(e)} fontSize="small" />

      <Menu
        id="settings-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleClose}>
          <a target="_blank" href="https://cookienotice.deloitte.com">
            Cookies
          </a>
        </MenuItem>
        <MenuItem onClick={() => handleClickOnCookieSettings()}>
          <a>Cookie Settings</a>
        </MenuItem>
      </Menu>
    </div>
  );
}; 

const mapDispatchToProps = (dispatch: any) => ({
	onTokenChange: (data: any) => dispatch({ type: TOKENDATA, data: data }),
});
export default connect(null, mapDispatchToProps)(Header);
